module.exports = __webpack_public_path__ + "static/img/jinka.20ae56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jinka.png
// module id = xiSL
// module chunks = 1